import { render, staticRenderFns } from "./RooftopDetail.vue?vue&type=template&id=7ae03200&"
import script from "./RooftopDetail.vue?vue&type=script&lang=js&"
export * from "./RooftopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports